/* Source: /home/sidsolaiyappan/skooch_ai/shared/tier_chips.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { getStoreDraggedSkillCat, getStoreDropTargetCat, getStoreDropTargetTier, getStoreCategoryTiers, getStoreIsMobileViewport } from "./store.js";
import { onTierDragEnter, onTierDrop, onTierDragEnd, onChipTapMobile, onTierTapMove } from "./profile_handlers.js";
function tierChipEls(tierList, tierNum) {
  let _dragged = getStoreDraggedSkillCat();
  let _dropCat = getStoreDropTargetCat();
  let _dropTier = getStoreDropTargetTier();
  let _chips = tierList.map(ct => {
    let _cl = "skill-chip";
    if ((_dragged === ct["category"])) {
      _cl = (_cl + " skill-item-dragging");
    } else if (((_dropCat === ct["category"]) && (_dropTier === tierNum))) {
      _cl = (_cl + " skill-item-over");
    }
    let _sty = {"background": ct["color"], "color": "#fff", "borderRadius": "999px", "marginRight": "6px", "marginBottom": "4px", "cursor": "grab"};
    return __jacJsx("span", {"key": ct["category"], "className": _cl, "draggable": "true", "onClick": () => {
      onChipTapMobile(ct["category"]);
    }, "onDragStart": e => {
      e.dataTransfer.setData("text/plain", ct["category"]);
      e.dataTransfer.effectAllowed = "move";
    }, "onDragOver": e => {
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
    }, "onDragEnter": e => {
      e.preventDefault();
      onTierDragEnter(ct["category"], tierNum);
    }, "onDragEnd": () => {
      onTierDragEnd();
    }, "onDrop": e => {
      e.preventDefault();
      onTierDrop(e, ct["category"], tierNum);
    }, "style": _sty}, [ct["label"]]);
  });
  let _selTier = 0;
  if ((_dragged && getStoreIsMobileViewport())) {
    for (const _ct of getStoreCategoryTiers()) {
      if ((_ct["category"] === _dragged)) {
        _selTier = _ct["tier"];
      }
    }
    if ((_selTier !== tierNum)) {
      _chips.push(__jacJsx("button", {"key": ("tier-move-target-" + String(tierNum)), "className": "skill-chip-move-target", "onClick": () => {
        onTierTapMove(tierNum);
      }}, ["Move here"]));
    }
  }
  return _chips;
}
export {tierChipEls};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:tierChipEls": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=tier_chips.js.map
